import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  width: 60rem;

  padding: 1.5rem 0;
`;

const Title = styled(Headline)`
  padding: 0 1.5rem;
`;

const InputWrapper = styled.div`
  padding: 1.5rem;
  margin: 1.5rem 0;

  border-top: 0.1rem solid ${pickColor('gray')};
  border-bottom: 0.1rem solid ${pickColor('gray')};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.2rem;

  padding-right: 1.5rem;
`;

export { Container, InputWrapper, ButtonWrapper, Title };
